import React from "react";
import { WorkOrder } from "../api/interfaces";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import Table from "@mui/joy/Table";
import Typography from "@mui/joy/Typography";
import { formatDate } from "../utils";

interface WorkOrderDetailsModalProps {
  open: boolean;
  workOrder: WorkOrder | null;
  onClose: () => void;
}

const WorkOrderDetailsModal: React.FC<WorkOrderDetailsModalProps> = ({
  open,
  workOrder,
  onClose,
}) => {
  if (!workOrder) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog aria-labelledby="work-order-details-modal">
        <ModalClose />
        <Typography id="work-order-details-modal" level="h2">
          Ordre de travail
        </Typography>
        <Table>
          <tbody>
            <tr>
              <td>
                <Typography level="body-sm">Num OT</Typography>
              </td>
              <td>
                <Typography level="body-sm">{workOrder.num_ot}</Typography>
              </td>
            </tr>
            <tr>
              <td>
                <Typography level="body-sm">Date</Typography>
              </td>
              <td>
                <Typography level="body-sm">
                  {formatDate(workOrder.date_intervention)}
                </Typography>
              </td>
            </tr>
            <tr>
              <td>
                <Typography level="body-sm">Status</Typography>
              </td>
              <td>
                <Typography level="body-sm">{workOrder.status_ot}</Typography>
              </td>
            </tr>
            <tr>
              <td>
                <Typography level="body-sm">Agent</Typography>
              </td>
              <td>
                <Typography level="body-sm">{workOrder.agent_name}</Typography>
              </td>
            </tr>
            <tr>
              <td>
                <Typography level="body-sm">Code</Typography>
              </td>
              <td>
                <Typography level="body-sm">
                  {workOrder.equipment_code}
                </Typography>
              </td>
            </tr>
            <tr>
              <td>
                <Typography level="body-sm">Compte Rendu</Typography>
              </td>
              <td>
                <Typography level="body-sm">
                  {workOrder.compte_rendu}
                </Typography>
              </td>
            </tr>
            <tr>
              <td>
                <Typography level="body-sm">Equipement</Typography>
              </td>
              <td>
                <Typography level="body-sm">
                  {workOrder.equipment_title}
                </Typography>
              </td>
            </tr>
            <tr>
              <td>
                <Typography level="body-sm">Symptome</Typography>
              </td>
              <td>
                <Typography level="body-sm">{workOrder.symptom}</Typography>
              </td>
            </tr>
            <tr>
              <td>
                <Typography level="body-sm">Cause</Typography>
              </td>
              <td>
                <Typography level="body-sm">{workOrder.cause}</Typography>
              </td>
            </tr>
            <tr>
              <td>
                <Typography level="body-sm">Défaut</Typography>
              </td>
              <td>
                <Typography level="body-sm">{workOrder.defect}</Typography>
              </td>
            </tr>
            <tr>
              <td>
                <Typography level="body-sm">Remede</Typography>
              </td>
              <td>
                <Typography level="body-sm">{workOrder.remedy}</Typography>
              </td>
            </tr>
            <tr>
              <td>
                <Typography level="body-sm">Ensemble</Typography>
              </td>
              <td>
                <Typography level="body-sm">
                  {workOrder.sub_assembly}
                </Typography>
              </td>
            </tr>
          </tbody>
        </Table>
      </ModalDialog>
    </Modal>
  );
};

export default WorkOrderDetailsModal;
